import React from 'react';
import backgroundImg from '../../../assets/images/physical_theropy/girl_on_chair.jpg';
import { motion } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';

const Condition = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  const TitleAndDescription = ({ title, description, index }) => {
    return (
      <motion.div
        initial={{ x: isMobile ? 0 : 60, opacity: 0, rotate: -2 }}
        whileInView={{ x: 0, opacity: 1, rotate: 0 }}
        transition={{
          type: 'spring',
          stiffness: 300,
          damping: 18,
          delay: 0.1 * index,
        }}
        viewport={{ once: true, amount: 0.9 }}
        className="flex flex-col gap-1 font-custom"
      >
        <h2 className="text-[26px] sm:text-[28px] text-[#7E4B9D] font-bold">
          {title}
        </h2>
        <p
          className="text-lg text-[#3A3A3A] max-w-auto lg:max-w-[400px] font-semibold"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </motion.div>
    );
  };

  return (
    <div
      className="w-full bg-cover bg-center bg-no-repeat flex"
      style={{
        backgroundImage: `url(${backgroundImg})`,
      }}
    >
      <main className="relative max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 z-10">
        <div className="mb-8">
          <h2 className="text-[34px] sm:text-[40px] md:text-[45px] text-[#7E4B9D] font-bold  justify-center leading-[50px]">
            Pediatric physical therapy can effectively <br /> address a wide
            range of conditions, including...
          </h2>
        </div>
        <div className="flex flex-col gap-10 items-end">
          <div className="flex flex-col md:flex-row gap-10 md:gap-20">
            <div className="flex-1 flex flex-col gap-4 sm:gap-10">
              <TitleAndDescription
                title="Developmental Delays"
                description="Children who experience delays in motor milestones such as sitting, crawling, walking, or running may benefit from targeted strengthening exercises, balance training, and more."
              />
              <TitleAndDescription
                title="Cerebral Palsy"
                description="Children with cerebral palsy often benefit from physical therapy interventions to improve muscle control, balance, postural stability, joint and muscle mobility, and crawling, walking, and running mechanics."
              />
              <TitleAndDescription
                title="Neuromuscular Disorders"
                description="Conditions like muscular dystrophy or spina bifida may require physical therapy to maintain and improve strength, manage symptoms, and optimize mobility."
              />
              <TitleAndDescription
                title="Orthopedic Injuries"
                description="Pediatric physical therapy can aid in the recovery and rehabilitation of children with fractures, sports injuries, concussions,  post-surgical procedures, and more."
              />
              <TitleAndDescription
                title="Coordination Disorders"
                description="Children with conditions like dyspraxia or developmental coordination disorder can benefit from physical therapy to improve coordination and motor planning skills."
              />
              <TitleAndDescription
                title="Genetic Disorders"
                description="Physical therapy plays a crucial role in managing the physical challenges associated with genetic disorders, such as Down syndrome or fragile X syndrome."
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Condition;
